// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExcelFilledSvg from "@ant-design/icons-svg/es/asn/FileExcelFilled";
import AntdIcon from '../components/AntdIcon';

var FileExcelFilled = function FileExcelFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelFilledSvg
  }));
};

FileExcelFilled.displayName = 'FileExcelFilled';
export default React.forwardRef(FileExcelFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileExcelFilled.js
// module id = 1093
// module chunks = 0